import NewErrorMessage from './NewErrorMessage';

export default NewErrorMessage;